/**
 * 百工分支 (🔨 工业科技) - 共18项
 * 严格按照 docs/TECH_TREE_DESIGN.md 设计
 */

import type { Tech } from '../TechTypes';

export const BAIGONG_TECHS: Tech[] = [
  // 第一层：基础工艺 (3项)
  {
    id: 'G001',
    name: '百工图谱',
    description: '工匠之道',
    branch: 'baigong',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { buildSpeedBonus: 1.1 },
    },
    position: { x: 20, y: 10 },
    icon: '📖',
  },
  {
    id: 'G002',
    name: '冶铁之术',
    description: '基础冶金',
    branch: 'baigong',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { mineIncome: 15 },
    },
    position: { x: 50, y: 10 },
    icon: '⚒️',
  },
  {
    id: 'G003',
    name: '伐木筑基',
    description: '林业开发',
    branch: 'baigong',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { buildSpeedBonus: 1.15 },
    },
    position: { x: 80, y: 10 },
    icon: '🪓',
  },

  // 第二层：进阶工艺 (5项)
  {
    id: 'G011',
    name: '匠作监法',
    description: '工部统筹',
    branch: 'baigong',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['G001'],
    effects: {
      bonuses: { buildSpeedBonus: 1.2, unitHealthBonus: 1.15 },
    },
    position: { x: 10, y: 25 },
    icon: '🏗️',
  },
  {
    id: 'G012',
    name: '百炼成钢',
    description: '精钢锻造',
    branch: 'baigong',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['G002'],
    effects: {
      bonuses: { mineIncome: 20, attackBonus: 1.1 },
    },
    position: { x: 30, y: 25 },
    icon: '⚙️',
  },
  {
    id: 'G013',
    name: '鲁班之术',
    description: '木工大师',
    branch: 'baigong',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['G003'],
    effects: {
      bonuses: { buildSpeedBonus: 1.2, siegeBonus: 1.15 },
    },
    position: { x: 50, y: 25 },
    icon: '🪚',
  },
  {
    id: 'G014',
    name: '采石开山',
    description: '石料开采',
    branch: 'baigong',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['G001'],
    effects: {
      bonuses: { defenseBonus: 1.2 },
    },
    position: { x: 70, y: 25 },
    icon: '🪨',
  },
  {
    id: 'G015',
    name: '砖瓦烧制',
    description: '砖窑技术',
    branch: 'baigong',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['G001'],
    effects: {
      bonuses: { buildSpeedBonus: 1.1, repairSpeed: 1.25 },
    },
    position: { x: 90, y: 25 },
    icon: '🧱',
  },

  // 第三层：高级工艺 (5项)
  {
    id: 'G021',
    name: '都江堰法',
    description: '水利工程',
    branch: 'baigong',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['G011', 'G014'],
    effects: {
      bonuses: { farmIncome: 20 },
    },
    position: { x: 10, y: 45 },
    icon: '🌊',
  },
  {
    id: 'G022',
    name: '神兵利器',
    description: '绝世锻造',
    branch: 'baigong',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['G012'],
    effects: {
      bonuses: { attackBonus: 1.12 },
    },
    position: { x: 30, y: 45 },
    icon: '🗡️',
  },
  {
    id: 'G023',
    name: '云梯冲车',
    description: '攻城利器',
    branch: 'baigong',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['G013'],
    effects: {
      bonuses: { siegeBonus: 1.3, speedBonus: 1.2 },
    },
    position: { x: 50, y: 45 },
    icon: '🏚️',
  },
  {
    id: 'G024',
    name: '长城之基',
    description: '坚城之术',
    branch: 'baigong',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['G014', 'G015'],
    effects: {
      bonuses: { defenseBonus: 1.4, repairSpeed: 1.5 },
    },
    position: { x: 70, y: 45 },
    icon: '🧱',
  },
  {
    id: 'G025',
    name: '秦砖汉瓦',
    description: '建筑奇观',
    branch: 'baigong',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['G015'],
    effects: {
      bonuses: { buildSpeedBonus: 1.15 },
    },
    position: { x: 90, y: 45 },
    icon: '🏛️',
  },

  // 第四层：大师工艺 (3项)
  {
    id: 'G031',
    name: '大国工匠',
    description: '工业巅峰',
    branch: 'baigong',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['G021', 'G025'],
    effects: {
      bonuses: { mineIncome: 20, farmIncome: 20, buildSpeedBonus: 1.3 },
    },
    position: { x: 20, y: 65 },
    icon: '🎖️',
  },
  {
    id: 'G032',
    name: '倚天屠龙',
    description: '神器锻造',
    branch: 'baigong',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['G022'],
    effects: {
      bonuses: { attackBonus: 1.25 },
    },
    position: { x: 50, y: 65 },
    icon: '⚔️',
  },
  {
    id: 'G033',
    name: '万里长城',
    description: '不朽工程',
    branch: 'baigong',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['G023', 'G024'],
    effects: {
      bonuses: { defenseBonus: 1.5, siegeBonus: 0.7 },
    },
    position: { x: 80, y: 65 },
    icon: '🏯',
  },

  // 第五层：终极工艺 (2项) [互斥]
  {
    id: 'G041',
    name: '造化之功',
    description: '生产终极：所有产出+35%，建造时间-40%',
    branch: 'baigong',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['G031'],
    mutuallyExclusive: ['G042'],
    effects: {
      bonuses: { mineIncome: 35, farmIncome: 35, buildSpeedBonus: 1.4 },
    },
    position: { x: 35, y: 85 },
    nodeShape: 'hexagon',
    icon: '🌟',
    quote: '天地之大德曰生',
  },
  {
    id: 'G042',
    name: '天工开物',
    description: '军工终极：解锁究极兵器，攻城伤害+50%',
    branch: 'baigong',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['G032', 'G033'],
    mutuallyExclusive: ['G041'],
    effects: {
      bonuses: { siegeBonus: 1.5, attackBonus: 1.2 },
    },
    position: { x: 65, y: 85 },
    nodeShape: 'hexagon',
    icon: '📚',
    quote: '天工开物，利用厚生',
  },
];
